// initializers
import experimentalRedirection from 'util/experimental';
import initLocales from 'init/initLocales';
import { initStore } from 'app/store';
import initHistory from 'init/initHistory';
import initRouterHistory from 'init/initRouterHistory';
import loadInitialPageData from 'init/loadInitialPageData';
import initDataDog from 'init/initDatadog';
import startApp from 'init/startApp';
import { initErrorHandlers } from 'api/errors';
import {
  setCameFromSubfieldN,
  setDefaultScriptType,
  setEntryPath,
  setRouteVersion
} from 'settings/index';
import { scriptTypes } from 'constants/scripts';

import {
  determineRouteVersion,
  determineDefaultScriptType,
  determineCameFromSubfieldN,
  determineStartingView,
  determineUserId
} from 'util/env';

import { fetchFeatureFlags } from './store/launchDarkly/actions';

// Pull in styling
import './styles';

import { makeCleanUrl, changeUrl } from 'util/routes';

(() => {
  // Redirect if the experimental hash is set for script-creator
  experimentalRedirection();

  const defaultReferrer = (document && document.referrer) || '';
  const hash = window.location.hash;
  const routeVersion = determineRouteVersion({ hash });
  const cameFromSubfieldN = determineCameFromSubfieldN({ referrer: defaultReferrer });

  const clientId: string = determineUserId();

  initDataDog(clientId);
  initLocales();

  let history = initHistory();
  const store = initStore({ history });
  const { dispatch, getState } = store;
  initErrorHandlers({ dispatch, getState });
  dispatch(fetchFeatureFlags({clientId}));
  dispatch(setCameFromSubfieldN(cameFromSubfieldN));
  dispatch(setRouteVersion(routeVersion));

  let defaultScriptType = determineStartingView({}) || scriptTypes.FERTILITY;

  if (cameFromSubfieldN) {
    defaultScriptType = determineDefaultScriptType({
      query: window.location.search,
      referrer: defaultReferrer
    });
  }

  dispatch(setDefaultScriptType(defaultScriptType));

  const url = window && window.location.href;
  if (url) {
    dispatch(setEntryPath(window.location.hash.substring(1)));
  }

  const newHref = makeCleanUrl({url, clientId});
  if(url !== newHref ) {
    changeUrl(newHref);
  }

  history = initRouterHistory({ store, history });
  startApp(store, history).then(() => {
    loadInitialPageData({ dispatch, getState });
  });
})();
